import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import API_BASE_URL from '../config';
import useAccess from '../hooks/useAccess';

const Logout = () => {
  const navigate = useNavigate();
  const { userId } = useAccess();

  useEffect(() => {
    const performLogout = async () => {
      try {
        // 1. Call backend logout API to destroy server-side session
        await axios.post(`${API_BASE_URL}/logout`, {}, { withCredentials: true });
      } catch (err) {
        // Ignore API errors to ensure logout completes locally regardless of server status
        console.warn("Logout API unreachable, proceeding with client-side cleanup.");
      } finally {
        // 2. Clear all app-related localStorage
        localStorage.removeItem('isLoggedIn');
        localStorage.removeItem('isPremium');
        
        if (userId) {
          localStorage.removeItem(`isPremium_${userId}`);
          // 3. Clear sessionStorage flags for this specific user
          sessionStorage.removeItem(`upgradeModalShown_${userId}`);
        }
        
        // Global fallbacks
        sessionStorage.removeItem('upgradeModalShown');

        // 4. Reset Application state
        // This triggers useAccess.js to invalidate its cache and forces UI updates
        window.dispatchEvent(new Event('goldpetals:access-refresh'));

        // 5. Redirect to login
        // replace: true prevents the user from navigating "Back" into the app
        navigate('/login', { replace: true });
      }
    };

    performLogout();
  }, [navigate, userId]);

  return null;
};

export default Logout;